import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/solid/arrow-down.svg'
import BaseIcon from '../../BaseIcon'

const ChartLineDown = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 448 512" />
}

ChartLineDown.propTypes = {
	className: PropTypes.string,
}

ChartLineDown.defaultProps = {
	className: null,
}
export default ChartLineDown
